import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { RootState } from "typesafe-actions";
import { toggleFullSize } from "../state/uiControl/uiControl.actions";
import { Display } from "../state/uiControl/uiControl.reducer";
import FsLightbox from "fslightbox-react";

const BASE_PATH =
  "https://" + process.env.REACT_APP_CMS_DOMAIN + "/anchor/api/";

export const ImageGallery = ({
  selected,
  toggleFullSize,
  selectedImage,
}: ImageBarProps) => {
  const [toggler, setToggler] = useState(false);

  useEffect(() => {
    if (selectedImage) {
      setToggler((toggler) => !toggler);
    }
  }, [selectedImage, selected]);

  const images = Object.values(selected?.files ?? {});

  if (!selected || !selected.files || !images.length || !selectedImage) {
    return null;
  }

  return (
    <FsLightbox
      toggler={toggler}
      onClose={() => toggleFullSize(null)}
      sources={images.map((i) => BASE_PATH + i.path)}
      source={selectedImage}
      type="image"
      key={selectedImage}
    />
  );
};

const mapStateToProps = (state: RootState, ownProps: any) => {
  let selected;

  switch (state.uiControl.showing) {
  case Display.PORT:
    selected = state.uiControl.selectedPort;
    break;
  case Display.ENTRY:
    selected = state.uiControl.selectedEntry;
    break;
  case Display.SPECIES:
    selected = state.uiControl.selectedSpecies;
    break;
  case Display.BULLETIN:
    selected = state.uiControl.selectedBulletin;
    break;
  }

  return {
    selectedImage: state.uiControl.selectedImage,
    selected: selected,
  };
};

const dispatchProps = {
  toggleFullSize,
};

type ImageBarProps = ReturnType<typeof mapStateToProps> & typeof dispatchProps;

export default connect(mapStateToProps, dispatchProps)(ImageGallery);
